import React from "react";
import Seo from "../components/Seo";
import Footer from "../components/Footer";
import Hero from "../components/Heros/HeroBusiness";
import Cta from "../components/Cta";
import Feature from "../components/Features/FeatureDreamfactory";


const Dreamfactory = () => (
    <>
        <Seo
            title="DreamFactory 자동생성 API"
            description="SQL·NoSQL 20여 종 데이터베이스 커넥터와 Salesforce·Okta·Snowflake 연동을 지원합니다. 코딩 없이 보안 REST API를 즉시 생성합니다."
            path="/dreamfactory"
        />
        <Hero />
        <Feature />
        <Cta preset="contact" product="DreamFactory" />
        <Footer />
    </>
);

export default Dreamfactory;